import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-behaviour-table',
  templateUrl: './behaviour-table.component.html',
  styleUrls: ['./behaviour-table.component.css']
})
export class BehaviourTableComponent implements OnInit {

  @Input() behaviourScore: any[] = [];
  active: string = "title";
  order: string = 'score.title';
  reverse: boolean = false;
  constructor() { }

  ngOnInit() {
    if (this.behaviourScore)
      this.behaviourScore = this.behaviourScore.map(el => ({ performance: (el.gainedMarks / el.totalMarks) * 100, ...el }));
  }
  setOrder(value: string, isReverse: boolean) {

    if (isReverse) {
      this.reverse = !this.reverse;
    }
    this.order = value;
  }
}
